import React from 'react';
import {
  ChevronLeft12Regular,
  ChevronLeft16Regular,
  ChevronLeft20Regular,
  ChevronLeft24Regular,
  ChevronLeft28Regular,
  ChevronLeft48Regular,
  ChevronRight12Regular,
  ChevronRight16Regular,
  ChevronRight20Regular,
  ChevronRight24Regular,
  ChevronRight28Regular,
  ChevronRight48Regular,
} from '@fluentui/react-icons';
import { pageDataService } from 'common/utilities';

export const ForwardIcon = ({ primaryFill, size = 16 }: { primaryFill?: string; size?: 12 | 16 | 20 | 24 | 28 | 48 }) => {
  const Icon = pageDataService.isRtlLocale()
    ? {
        12: ChevronLeft12Regular,
        16: ChevronLeft16Regular,
        20: ChevronLeft20Regular,
        24: ChevronLeft24Regular,
        28: ChevronLeft28Regular,
        48: ChevronLeft48Regular,
      }[size]
    : {
        12: ChevronRight12Regular,
        16: ChevronRight16Regular,
        20: ChevronRight20Regular,
        24: ChevronRight24Regular,
        28: ChevronRight28Regular,
        48: ChevronRight48Regular,
      }[size];

  return <Icon primaryFill={primaryFill} />;
};
